// eslint-disable-next-line import/no-duplicates
import { addHours, format, isToday, isTomorrow } from "date-fns";
// eslint-disable-next-line import/no-duplicates
import { ptBR } from "date-fns/locale";

export const formatDateToDateTime = (date: string | number) => {
  return format(new Date(date), "dd/MM/yyyy HH:mm");
};

export const formatDateToHour = (date: string | number) => {
  return format(new Date(date), "HH:mm");
};

export const formatDateToDate = (date: string | number) => {
  return format(new Date(date), "dd/MM/yyyy");
};

export const addHoursToDate = (date: string | number, hours: number) => {
  return format(addHours(new Date(date), hours), "HH:mm");
};

export const getRelativeDayLabel = (date: string | number): string => {
  const d = new Date(date);
  if (isToday(d)) return "hoje";
  if (isTomorrow(d)) return "amanhã";
  return format(d, "dd/MM/yyyy", { locale: ptBR });
};

export const formatTimeLocal = (date: Date): string => {
  const h = date.getHours().toString().padStart(2, "0");
  const m = date.getMinutes().toString().padStart(2, "0");
  return `${h}:${m}`;
};
